module.exports = __webpack_public_path__ + "static/media/doyoung-8.jpeg";